import { TriggerAttribution, TriggerSourceEnum } from 'frontend/core/src/data/apis/types';

import { KeyValPair } from '../../Components/KeyValuePair';
import { AttributionInfo } from './AttributionInfo';
import { RunLink } from './RunLink';
import { TriggerSourceBadge } from './SourceBadges';
import { ResolvePerson } from './useRunPersonResolver';

export function TriggerInfo({
  triggeredBy,
  parentRunId,
  rerunOfRunId,
  resolvePerson,
  teamId,
  hasRun,
  onSelectRun
}: {
  triggeredBy?: TriggerAttribution;
  parentRunId?: string;
  rerunOfRunId?: string;
  resolvePerson: ResolvePerson;
  teamId?: string;
  hasRun: (runId: string) => boolean;
  onSelectRun: (runId: string) => void;
}) {
  const relatedRunRows: KeyValPair = {};
  // children recorded before trigger tracking have a parent id but no triggeredBy
  if (parentRunId && (!triggeredBy || triggeredBy.source === TriggerSourceEnum.PARENT_RUN)) {
    relatedRunRows['Parent Run ID'] = {
      value: <RunLink runId={parentRunId} hasRun={hasRun} onSelectRun={onSelectRun} />
    };
  }
  if (rerunOfRunId) {
    relatedRunRows['Re-run Of'] = {
      value: <RunLink runId={rerunOfRunId} hasRun={hasRun} onSelectRun={onSelectRun} />
    };
  }

  return (
    <AttributionInfo
      header='Trigger Info'
      attribution={triggeredBy}
      sourceBadge={triggeredBy && <TriggerSourceBadge source={triggeredBy.source} />}
      resolvePerson={resolvePerson}
      teamId={teamId}
      extraRows={relatedRunRows}
      data-test-id='sql-pipeline-run-details-trigger-info'
    />
  );
}
